import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';

@Injectable()
export class ActionBarService {
  private actionBarPortal$: BehaviorSubject<TemplatePortal<any>> = new BehaviorSubject(null);
  private actionBarButtonsPortal$: BehaviorSubject<TemplatePortal<any>> = new BehaviorSubject(null);

  private allowFloatingButtonSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private hideActionBarOnMobileSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  get portal$() {
    return this.actionBarPortal$.asObservable();
  }

  get buttonsPortal$() {
    return this.actionBarButtonsPortal$.asObservable();
  }

  set actionBar(templatePortal: TemplatePortal<any>) {
    this.actionBarPortal$.next(templatePortal);
    !templatePortal && this.hideActionBarOnMobileSubject$.next(false);
  }

  set actionBarButtons(templatePortal: TemplatePortal<any>) {
    this.actionBarButtonsPortal$.next(templatePortal);
    !templatePortal && this.allowFloatingButtonSubject$.next(false);
  }

  set allowFloatingButton(value: boolean) {
    this.allowFloatingButtonSubject$.next(value);
  }

  get allowFloatingButton$() {
    return this.allowFloatingButtonSubject$.asObservable();
  }

  set hideActionBarOnMobile(value: boolean) {
    this.hideActionBarOnMobileSubject$.next(value);
  }

  get hideActionBarOnMobile$() {
    return this.hideActionBarOnMobileSubject$.asObservable();
  }
}
